"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPriceDropValue = exports.PriceDropType = void 0;
var react_1 = require("react");
var TileDataContext_1 = require("../components/TileDataContext");
var PriceDropType;
(function (PriceDropType) {
    PriceDropType["NewPrice"] = "New Price";
    PriceDropType["PriceDrop"] = "Price Drop";
})(PriceDropType || (exports.PriceDropType = PriceDropType = {}));
var priceDropRestrictedStates = [
    'AR',
    'CA',
    'CT',
    'IL',
    'LA',
    'OR',
    'TX',
    'UT'
];
function getPriceDropValue(vehicle) {
    var _a;
    return vehicle.previousPrice && ((_a = vehicle.price) === null || _a === void 0 ? void 0 : _a.total)
        ? vehicle.previousPrice - vehicle.price.total
        : 0;
}
exports.getPriceDropValue = getPriceDropValue;
function usePriceDrop() {
    var state = (0, TileDataContext_1.useTileDataContext)().userInfo.location.state;
    var restrictedState = priceDropRestrictedStates.includes(state);
    var bannerText = (0, react_1.useMemo)(function () {
        return restrictedState
            ? 'We’ve updated prices on select vehicles, don’t miss out!'
            : 'We’ve lowered prices to give you more savings. Don’t miss out!';
    }, [restrictedState]);
    var displayText = (0, react_1.useMemo)(function () { return (restrictedState ? PriceDropType.NewPrice : PriceDropType.PriceDrop); }, [restrictedState]);
    var getPriceDrop = (0, react_1.useCallback)(function (vehicle) {
        var priceDrop = getPriceDropValue(vehicle);
        var showPriceDrop = Boolean(vehicle.previousPrice && priceDrop > 0);
        return {
            priceDrop: priceDrop,
            showPriceDrop: showPriceDrop
        };
    }, []);
    return {
        displayText: displayText,
        bannerText: bannerText,
        getPriceDrop: getPriceDrop,
        restrictedState: restrictedState
    };
}
exports.default = usePriceDrop;
//# sourceMappingURL=usePriceDrop.js.map